export enum CardPopupRef {
  Status = 'statusPickerWrap',
  Sprint = 'sprintPickerWrap',
}
